export default "__VITE_ASSET__PVZwLEnL__"